// extracted by mini-css-extract-plugin
export default {"container":"MBUSKJ","item":"UZa2Xr"};